var BufferList = require('bufferlist');


var PinnedBufferList = BufferList.extend({
    comparator: function (buffer) {
        return buffer.pinned;
    },
    addAt: function (buffer, idx, options) {
        buffer.pinned = idx;
        var ret = this.add(buffer, options);
        this.trigger('changed');
        return ret;
    },
    addAtEnd: function (buffer, options) {
        return this.addAt(buffer, this.length, options);
    },
    unpin: function (buffer) {
        delete buffer.pinned;
        var ret = this.remove(buffer, {silent: true});
        this.trigger('changed');
        return ret;
    },
    isAmbiguous: function (buffer) {
        var groups = this.groupBy(function (buf) {
            return buf.getDisplayName();
        });
        var group = groups[buffer.getDisplayName()];
        if (group && group.length > 1) {
            return true;
        } else {
            return false;
        }
    },
    onChange: function () {
        this.trigger('fullChange');
    },
    bids: function () {
        return this.pluck('bid');
    },
    isPinned: function (buffer) {
        return this.contains(buffer);
    },
    isEmpty: function () {
        return !this.length;
    },
});


module.exports = PinnedBufferList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/pinnedbufferlist.js
// module id = xUqH
// module chunks = 1